var nodeParser = require('./nodeParser');
var nodeModifier = require('./nodeModifier');

var OWN_NODES = ['VG-IS', 'VG-IS-ORIG', 'VG-IS-DIAL', 'GU-SC', 'GU-SC_ORIG', 'GU-SC-DIAL'];
var EXCLUDED_NODES = [
	'IMG', 'SCRIPT', 'META', 'BASE', 'BR', 'INPUT', 'TEXTAREA', 'STYLE', 'NOSCRIPT', 'IFRAME', 'PRE', 'TEXT', 'OPTION', 'XMP', 'SVG', 'PATH', 'CODE'
];

import { share } from '../share';

//window.scContentCustomParsers = window.scContentCustomParsers || [];
share.scTopZIndex = 1000;

function recurseDomChildren(startNode) {
  if (startNode.style && startNode.style.zIndex) {
    var zIndex = parseInt(startNode.style.zIndex);
    if (zIndex > share.scTopZIndex) share.scTopZIndex = zIndex;
  }
  // if (startNode.nodeType === 8) { //skip comment nodes, already ignored earlier
  //   return;
  // }
  if (startNode.nodeType === 3) {
    if (!!startNode.data.trim()) {
      if (
        startNode.parentNode && startNode.parentNode.tagName === 'VG-IS-ORIG' || 
        (EXCLUDED_NODES.indexOf(startNode.parentNode.tagName) !== -1)
      ) {
        return;
      }
      return nodeParser.parse(startNode);
    }
  }
  if (!startNode.tagName) {
    return;
  }
  var nodeTagName = startNode.tagName.toUpperCase();
  if (OWN_NODES.indexOf(nodeTagName) !== -1) {
    return;
  } else if (EXCLUDED_NODES.indexOf(nodeTagName) === -1) {
    [].slice.call(startNode.childNodes).forEach(recurseDomChildren);
  } else if (nodeTagName === 'INPUT') {
    // for (var cp in window.scContentCustomParsers) {
    //   var customParser = window.scContentCustomParsers[cp];
    //   if (startNode.matches && startNode.matches(customParser.selector)) {
    //     try {
    //       if (customParser.parse(startNode)) break;
    //     } catch(err) {}
    //   }
    // }
  }
}

function revertDomChildren(startNode) {
  [].slice.call(startNode.querySelectorAll('vg-is')).forEach(nodeModifier.revert);
}

module.exports = {
  recurseDomChildren: recurseDomChildren,
  revertDomChildren: revertDomChildren
};